import axios from 'axios';
import store from '@/store';

const apiPath = `${store.state.apiPathWithVersion}/urlShort`;

export default {
  async getCode(params) {
    try {
      let apiUrl = store.state.countrySelected.api;
      let resp = await axios.get(`${apiUrl}/${apiPath}/shortUrl`, {
        params: params
      });

      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  }
};
